/**
 * @file index.tsx
 *
 * @fileoverview Button to show all jobs.
 */

import React from 'react';
import Link from '~/jobiqo/components/Link';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { AddIcon } from '~/vcl/icons/Add';
import NextLink from 'next/link';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface ShowAllJobsButtonProps {
  /**
   * The frontend theme
   */
  frontendTheme: any;
  /**
   * Query params to be added to the path.
   */
  queryParams?: string;
}

const ShowAllJobsButton = ({
  frontendTheme,
  queryParams,
}: ShowAllJobsButtonProps) => {
  const { JOBS } = useFrontendConfig();

  return (
    <Link
      href={JOBS.JOBS_PAGE + '?' + (queryParams ?? '')}
      prefetch={false}
      asChild
    >
      <LinkButton
        buttonStyle={
          frontendTheme.LANDING_PAGES.JOB_TEASERS.SHOW_ALL_BUTTON_STYLE
        }
        raised={false}
        linkElement={NextLink}
      >
        <AddIcon title="Show more" />
        <span>
          <FormattedMessage
            id="landing_jobs_link"
            defaultMessage="See all jobs"
          />
        </span>
      </LinkButton>
    </Link>
  );
};

export default ShowAllJobsButton;
